import applyAnimation from '@lib/animation/applyAnimation'
import animationPresets from '@lib/animation/presets'
import type { MutableRefObject } from 'react'

export const getScrollAnimationsForRef = (
  elementToAnimate: MutableRefObject<null>,
) => {
  const scrollIn = () => {
    applyAnimation({
      animationOptions: animationPresets.fadeInUp({
        delay: 200,
        duration: 1000,
      }),
      element: elementToAnimate.current,
      loop: false,
    })
  }

  const scrollOut = () => {
    applyAnimation({
      animationOptions: animationPresets.fadeOutUp({ duration: 1000 }),
      element: elementToAnimate.current,
      loop: false,
    })
  }
  return { scrollIn, scrollOut }
}
